import "./ButtonFilter.scss";
import { createSpreadableBem } from "/Helpers/createBem";

export interface Props {
  onClick?: () => void;
  caption: string;
  selected: boolean;
  asLink?: boolean;
  href?: string;
}

const ButtonFilter = ({ onClick, caption, selected, asLink, href }: Props) => {
  const bem = createSpreadableBem("button-filter-norad");
  return asLink ? (
    <a
      href={href}
      {...bem("", {
        "--selected": selected,
      })}
    >
      <span {...bem("__caption")}>{caption}</span>
    </a>
  ) : (
    <button
      onClick={onClick}
      {...bem("", {
        "--selected": selected,
      })}
    >
      <span {...bem("__caption")}>{caption}</span>
    </button>
  );
};

export default ButtonFilter;
